import NoWrapTableCell from 'Components/NoWrapTableCell'
import StyledLink from 'Components/StyledLink'
import StyledTableRow from 'Components/StyledTableRow'
import type { TicketShape } from 'Services/SalesManagement/Features/AffiliateProduct/affiliateProductSlice'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import type { FC } from 'react'

const TicketListRow: FC<{
  row: TicketShape
}> = ({ row }) => {
  return (
    <StyledTableRow hover>
      <NoWrapTableCell title={showValueOrHyphen(row.external_id)} component="th" scope="row">
        <StyledLink
          to={{
            pathname: `${SALES_MANAGEMENT_ROOT_URL}/transfer-management/${row.id}/`
          }}
          state={{
            singleTicket: JSON.stringify(row)
          }}
        >
          {showValueOrHyphen(row.external_id)}
        </StyledLink>
      </NoWrapTableCell>
      <NoWrapTableCell title={row.product_name}>{row.product_name}</NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.ticket_id)}>
        {showValueOrHyphen(row.ticket_id)}
      </NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.payment_method)}>
        {showValueOrHyphen(row.payment_method)}
      </NoWrapTableCell>
      <NoWrapTableCell title={datetimeFormatter(row.external_creation_date)}>
        {datetimeFormatter(row.external_creation_date)}
      </NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.waltti_id)}>
        {showValueOrHyphen(row.waltti_id)}
      </NoWrapTableCell>
    </StyledTableRow>
  )
}

export { TicketListRow }
